import { CookieMethod } from '../dispatcher/Types';
import { Action, OperationType } from '..';

export const redirectToConsentPage: Action = [{
  consent: true,
  type: OperationType.redirect
}];

export const changeLanguage: Action = [{
  condition: '{locale}',
  conditionOperations: [{
    args: ['locale'],
    moduleName: 'CookieManager',
    mappingName: 'isLanguageChanged',
    name: 'changeLanguage',
    type: OperationType.addOperationData
  }, {
    condition: '!{isLanguageChanged} && !{firstLoadApp}',
    conditionOperations: [{
      data: {
        cookiesMissing: true
      },
      name: 'functionalCookiesMissingWarning',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const checkCookieConsent: Action = [{
  moduleName: 'CookieManager',
  mappingName: 'consentUrl',
  name: 'getConsentUrl',
  type: OperationType.addOperationData
}, {
  condition: '{consentUrl}',
  conditionOperations: [{
    moduleName: 'CookieManager',
    name: 'hasRequiredCookie',
    type: OperationType.addOperationData
  }, {
    condition: '!{hasRequiredCookie}',
    conditionOperations: [{
      consent: true,
      type: OperationType.redirect
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    condition: '!{firstLoadApp}',
    conditionOperations: [{
      name: 'consentUrlMissingWarning',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const consentUrlMissingWarning: Action = [];

export const checkCookiesBeforeRouteChanges: Action = [{
  method: CookieMethod.checkConsent,
  type: OperationType.cookie
}, {
  data: {
    defaultValue: false
  },
  moduleName: 'RouterUtil',
  mappingName: 'routeHasMatch',
  name: 'matchRoute',
  args: ['defaultValue'],
  type: OperationType.addOperationData
}, {
  condition: '{routeHasMatch}',
  conditionOperations: [{
    moduleName: 'CookieManager',
    name: 'beforeRouteChange'
  }],
  type: OperationType.conditional
}];
